export const InitialValuesIngCCTP = {
	title: "",
	content: "",
	origin: "",
}
